const translations = {
  ar: {
    // ── عام ──
    appName: 'قادر',
    appSlogan: 'أنت قادر — وجّه مسارك',
    logout: 'خروج',
    back: 'رجوع',
    loading: 'جاري التحميل...',
    loadingData: 'جاري تحميل بياناتك...',
    save: 'حفظ',
    send: 'إرسال',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    error: 'خطأ',
    success: 'تم بنجاح',
    perMonth: 'ر.س/شهر',
    currency: 'ر.س',
    daysLeft: 'يوم متبقي',
    readMore: 'اقرأ المزيد عن قادر ←',

    // ── PhoneAuth ──
    auth_tagline: 'أنت قادر — وجّه مسارك نحو التفوّق',
    auth_enterPhone: 'أدخل رقم جوالك',
    auth_smsSent: 'سنرسل لك رمز تحقق عبر SMS',
    auth_sendCode: 'إرسال رمز التحقق',
    auth_sending: 'جاري الإرسال...',
    auth_browseAsGuest: '👀 تصفّح كضيف',
    auth_verifyTitle: 'رمز التحقق',
    auth_codeSentTo: 'أرسلنا رمزاً إلى',
    auth_verify: 'تحقق ودخول',
    auth_verifying: 'جاري التحقق...',
    auth_resendAfter: 'إعادة الإرسال بعد',
    auth_resend: 'إعادة إرسال الرمز',
    auth_changeNumber: 'تغيير الرقم',
    auth_agree: 'بالمتابعة أنت توافق على شروط الخدمة',
    auth_invalidPhone: 'أدخل رقم جوال صحيح',
    auth_invalidCode: 'أدخل رمز التحقق',
    auth_testimonialTitle: 'ماذا قال مستخدمونا',
    auth_realRatings: 'تقييمات حقيقية من مستخدمي قادر',

    // ── HomeScreen ──
    home_registerNow: 'سجّل الآن',
    home_guestBanner: '👀 أنت تتصفح كضيف',
    home_guestDesc: 'سجّل مجاناً لحفظ تقدّمك وبدء التدريب الفعلي',
    home_currentPlan: 'اشتراكك الحالي',
    home_planBadge: 'باقة',
    home_renewWarning: '⚠️ اشتراكك ينتهي قريباً — جدّد الآن للاستمرار',
    home_stats: '📊 إحصائياتك',
    home_pdfReport: '📄 تقرير PDF',
    home_questionsAnswered: 'سؤال أجبته',
    home_accuracy: 'دقة الإجابات',
    home_trainingSessions: 'جلسة تدريب',
    home_sessions: 'جلسة',
    home_questions: 'سؤال',
    home_streak: 'متتالية • Streak',
    home_streakBest: 'أفضل:',
    home_day: 'يوم',
    home_days: 'أيام',
    home_startTraining: '🚀 ابدأ تدريباً',
    home_comingSoon: '🔜 قريباً',
    home_upgrade: '🔒 ترقية',
    home_upgradePlan: '⬆️ ترقية الباقة — شاهد جميع الباقات',
    home_wrongAnswers: 'أسئلتي الخاطئة',
    home_wrongAnswersDesc: 'راجع الأسئلة التي أخطأت فيها وتعلّم منها',
    home_officialExam: 'محاكاة الاختبار الرسمي',
    home_officialExamDesc: '120 سؤال • 65 كمي + 55 لفظي • 120 دقيقة',
    home_trialExam: 'اختبار تجريبي',
    home_trialExamDesc: '20 سؤال عشوائي من بنك الأسئلة',
    home_recentSessions: '🕐 آخر جلساتك',
    home_noSessions: 'ما أجريت أي جلسة بعد',
    home_noSessionsDesc: 'ابدأ تدريباً من الأزرار أعلاه',
    home_trainingSession: 'جلسة تدريب',
    home_aboutTitle: 'منصة التدريب على اختبارات القدرات والتحصيلي',
    home_aboutDesc: 'نُمكّن كل طالب سعودي من تحقيق أعلى درجاته بأقل جهد وأذكى أسلوب — تدريب يومي منظّم، وأسئلة حقيقية، وتغذية راجعة فورية.',
    home_feature1: 'كمي · لفظي · تحصيلي · STEP',
    home_feature2: 'محاكاة الاختبار الرسمي',
    home_feature3: 'تقارير أداء تفصيلية',
    home_feature4: 'مراجعة الأسئلة الخاطئة',

    // ── Plans ──
    plans_title: 'اختر باقتك',
    plans_subtitle: 'ابدأ رحلتك نحو التفوّق',
    plans_yourScore: 'نتيجتك:',
    plans_mostPopular: 'الأكثر شيوعاً',
    plans_subscribe: 'اشترك في',
    plans_privacy: 'سياسة الخصوصية',
    plans_terms: 'الشروط والأحكام',
    plans_refund: 'سياسة الاسترجاع',
    plans_basic: 'أساسي',
    plans_pro: 'متقدم',
    plans_elite: 'شامل',
    plans_basicDesc: 'للمبتدئين',
    plans_proDesc: 'الأكثر شيوعاً',
    plans_eliteDesc: 'تجربة كاملة',
    feat_qudraat: 'أسئلة قدرات (كمي + لفظي)',
    feat_trial: 'اختبار تجريبي',
    feat_tahsili: 'أسئلة تحصيلي (رياضيات، فيزياء، كيمياء، أحياء)',
    feat_unlimited: 'أسئلة غير محدودة',
    feat_ai: 'شرح بالذكاء الاصطناعي ✨',
    feat_stats: 'إحصائيات الأداء',
    feat_progress: 'تتبع التقدم التفصيلي',
    feat_step: 'أسئلة Step',
    feat_tajamuat: '🗂️ تجمعات محدث',
    feat_support: 'أولوية الدعم',

    // ── Streak badges ──
    badge_champion: 'بطل',
    badge_advanced: 'متقدم',
    badge_committed: 'ملتزم',
    badge_regular: 'منتظم',
    badge_beginner: 'مبتدئ',

    // ── Plan names ──
    plan_noSub: 'بدون اشتراك',
    plan_guest: 'ضيف',

    // ── Modes ──
    mode_quant: 'كمي',
    mode_verbal: 'لفظي',
    mode_tahsili: 'تحصيلي',
    mode_tajamuat: 'تجمعات محدث',

    // ── StudyScreen / ExamScreen ──
    study_report: 'أبلغ عن مشكلة',
    study_note: 'ملاحظاتك على السؤال',
    study_submit: 'إرسال البلاغ',
    study_sending: 'جاري الإرسال...',
    study_submitError: 'حدث خطأ، حاول مجدداً',
    study_reportSent: '✅ تم إرسال بلاغك، شكراً!',
    study_explanation: 'الشرح',
    study_aiExplain: '✨ اشرح لي بالذكاء الاصطناعي',
    study_loadingAi: '⏳ جاري توليد الشرح...',
    study_noExplan: 'لا يوجد شرح لهذا السؤال',
    study_next: 'التالي ←',
    study_finish: 'إنهاء الجلسة',
    study_question: 'سؤال',
    study_of: 'من',
    study_correct: 'صحيح',
    study_wrong: 'خطأ',
    study_unanswered: 'لم تُجب',
    study_score: 'نتيجتك',
    study_accuracy: 'الدقة',
    study_timeTaken: 'الوقت المستغرق',
    study_restart: 'جلسة جديدة',
    study_home: 'الرئيسية',
    study_reviewAnswers: 'مراجعة الإجابات',
    study_hideReview: 'إخفاء المراجعة',
    study_yourAnswer: 'إجابتك:',
    study_correctAnswer: 'الإجابة الصحيحة:',
    study_loadingQuestions: 'جاري تحميل الأسئلة...',
    study_noQuestions: 'لا توجد أسئلة متاحة',
    study_errorLoading: 'حدث خطأ في تحميل الأسئلة',

    // ── ExamScreen ──
    exam_title: 'محاكاة الاختبار الرسمي',
    exam_quant: 'كمي',
    exam_verbal: 'لفظي',
    exam_timeUp: 'انتهى الوقت!',
    exam_submitExam: 'تسليم الاختبار',
    exam_confirmSubmit: 'هل أنت متأكد من تسليم الاختبار؟',
    exam_yes: 'نعم، سلّم',
    exam_no: 'لا، ارجع',
    exam_unansweredWarning: 'لديك أسئلة لم تُجب عليها',

    // ── WrongAnswers ──
    wrong_title: 'أسئلتي الخاطئة',
    wrong_empty: 'لا توجد أسئلة خاطئة بعد!',
    wrong_emptyDesc: 'استمر في التدريب وستظهر هنا الأسئلة التي تحتاج مراجعة',
    wrong_filter: 'تصفية حسب المادة',
    wrong_all: 'الكل',

    // ── PaymentScreen ──
    payment_title: 'إتمام الاشتراك',
    payment_plan: 'الباقة المختارة',
    payment_total: 'المبلغ الإجمالي',
    payment_processing: 'جاري المعالجة...',
    payment_pay: 'ادفع الآن',
    payment_success: '🎉 تم الاشتراك بنجاح!',
    payment_failed: 'فشلت عملية الدفع، حاول مجدداً',
    payment_back: 'رجوع إلى الباقات',

    // ── Admin ──
    admin_title: 'لوحة التحكم',
    admin_home: 'الرئيسية',
    admin_visitors: 'الزوار',
    admin_users: 'المستخدمون',
    admin_paid: 'المدفوعات',
    admin_questions: 'الأسئلة',
    admin_hidden: 'الأسئلة المخفية',
    admin_reports: 'البلاغات',
    admin_opinions: 'الآراء',
    admin_telegram: 'بوت تيليقرام',
    admin_totalRevenue: 'الإيرادات الكلية',
    admin_activeQuestions: 'الأسئلة النشطة',
    admin_todaySessions: 'جلسات اليوم',
    admin_activeSubscribers: 'المشتركون النشطون',
    admin_totalUsers: 'إجمالي المستخدمين',
    admin_activeBySubject: '📋 الأسئلة النشطة حسب القسم',
    admin_subject: 'القسم',
    admin_count: 'عدد الأسئلة',
    admin_pct: 'النسبة',
    admin_dashboard: 'لوحة المعلومات',

    // ── TrialQuiz ──
    trial_title: 'اختبار تجريبي',
    trial_subtitle: 'جرّب مستواك قبل ما تشترك',
    trial_home: '← الرئيسية',
    trial_savedSession: '⏸️ جلسة محفوظة',
    trial_answered: 'أجبت على',
    trial_from: 'من',
    trial_questions: 'سؤال',
    trial_resume: '▶ متابعة',
    trial_chooseSection: '📚 اختر قسماً أو اتركه على الكل:',
    trial_chooseSubject: '🎓 اختر مادة أو اتركها على الكل:',
    trial_all: 'الكل',
    trial_start: 'ابدأ الاختبار 🚀',
    trial_skip: 'تخطّي والذهاب للباقات',
    trial_login: '🔑 لدي اشتراك — دخول',
    trial_loading: 'جاري تحميل الأسئلة...',
    trial_exit: '✕ خروج',
    trial_exitTitle: 'هل تريد الخروج؟',
    trial_continueExam: '▶ واصل الاختبار',
    trial_saveAndExit: '💾 حفظ التقدم والخروج',
    trial_exitNoSave: 'خروج بدون حفظ',
    trial_navigate: 'تنقّل بين الأسئلة',
    trial_correct: 'صحيح',
    trial_wrong: 'خطأ',
    trial_remaining: 'متبقي',
    trial_next: 'التالي ←',
    trial_viewResult: 'عرض النتيجة 🏆',
    trial_reportProblem: '🚩 إبلاغ عن مشكلة في السؤال',
    trial_sendReport: '📤 إرسال الإبلاغ',
    trial_reportSending: '⏳ جاري الإرسال...',
    trial_reportFailed: '⚠️ فشل الإرسال، حاول مجدداً',
    trial_sent: 'تم الإرسال',
    trial_thanks: 'شكراً لمساعدتك في تحسين المنصة',
    trial_result: 'النتيجة النهائية',
    trial_correctFrom: 'إجابة صحيحة من',
    trial_aiAnalyze: 'حلّل أدائي بالذكاء الاصطناعي',
    trial_aiStrengths: 'نقاط قوتك وضعفك وتوصية',
    trial_aiAnalyzing: '✨ جاري تحليل أدائك...',
    trial_aiTitle: '🤖 تحليل الذكاء الاصطناعي',
    trial_subscribe: '🔓 اشترك للوصول لـ +10,000 سؤال ⭐',
    trial_shareWhatsapp: 'شارك نتيجتك على واتساب',
    trial_writeReview: 'اكتب رأيك في المنصة',
    trial_newTest: '🔄 اختبار جديد',
    trial_feedbackTitle: 'يهمّنا رأيك',
    trial_feedbackSubtitle: 'كيف كانت تجربتك مع الاختبار التجريبي؟',
    trial_feedbackThanks: 'شكراً لك!',
    trial_feedbackHelped: 'رأيك يساعدنا نطوّر قادر لتجربة أفضل',
    trial_feedbackSend: 'إرسال الرأي ✅',
    trial_feedbackSkip: 'تخطي والمتابعة ←',
    trial_feedbackChoose: 'اختر تقييمك أولاً ☝️',
    trial_comingSoon: 'قريباً',
    trial_questionCorrect: 'هل السؤال صحيح؟',
    trial_additionalDetails: 'تفاصيل إضافية (اختياري)...',
    trial_questionNote: 'ملاحظاتك على السؤال',
    trial_kmi: 'كمي',
    trial_lafzi: 'لفظي',
    trial_secUnit: 'ث',
    trial_perQ: 'للسؤال',
    trial_explainLabel: 'شرح',
    trial_perAnswer: 'لكل إجابة',
    trial_fetchingSubject: 'سيتم جلب أسئلة {sub} فقط',

    // ── SubjectScreen ──
    subject_title: 'اختر المادة',
    subject_subtitle: 'حدّد المادة التي تريد التدرّب عليها',
    subject_questions: 'سؤال',
    subject_back: '← رجوع',

    // ── WrongAnswers ──
    wrong_back: '← رجوع',
    wrong_noExplain: 'لا يوجد شرح',

    // ── StudyScreen (extra) ──
    study_savedSession: 'لديك جلسة محفوظة',
    study_resumeBtn: '▶ متابعة من حيث توقفت',
    study_newSessionBtn: '🔄 بدء جلسة جديدة',
    study_empty: 'لا توجد أسئلة',
    study_emptyDesc: 'لا توجد أسئلة في هذا الوضع حالياً',
    study_sessionEnd: 'انتهت الجلسة',
    study_exit: '✕ خروج',
    study_exitTitle: 'هل تريد الخروج؟',
    study_continueTraining: '▶ واصل التدريب',
    study_saveAndExit: '💾 حفظ التقدم والخروج',
    study_exitNoSave: 'خروج بدون حفظ',
    study_navigate: 'تنقّل بين الأسئلة',
    study_viewResult: 'عرض النتيجة 🏆',
    study_flag: '⚐ تميز للمراجعة',
    study_flagged: '⚑ محدد للمراجعة',
    study_aiAnalyzeBtn: 'تحليل أدائك بالذكاء الاصطناعي',
    study_aiSubtitle: 'نقاط قوتك • نقاط ضعفك • توصية للجلسة القادمة',
    study_aiAnalyzing: '✨ جاري تحليل أدائك...',
    study_aiTitle: '🤖 تحليل الذكاء الاصطناعي',
    study_shareWhatsapp: 'شارك نتيجتك على واتساب',
    study_reportSentTitle: 'تم الإرسال',
    study_reportSentDesc: 'شكراً لمساعدتك في تحسين المنصة',
    study_reportProblem: '🚩 إبلاغ عن مشكلة في السؤال',
    study_reportSending: '⏳ جاري الإرسال...',
    study_reportFailed: '⚠️ فشل الإرسال، حاول مجدداً',
    study_writeReview: 'اكتب رأيك في المنصة',
    study_reviewDone: 'شكراً لرأيك!',
    study_reviewHelps: 'يساعدنا في تطوير المنصة',
    study_chooseRating: 'اختر تقييمك أولاً ☝️',
    study_sendReview: '✅ إرسال الرأي',
    study_namePlaceholder: 'اسمك (اختياري)',
    study_commentPlaceholder: 'أي ملاحظة تريد مشاركتها؟ (اختياري)',
    study_stagePlaceholder: 'المرحلة الدراسية (اختياري)',
    study_detailsPlaceholder: 'تفاصيل إضافية (اختياري)...',
    study_grid_current: 'الحالي',
    study_grid_correct: 'صحيح',
    study_grid_wrong: 'خطأ',
    study_grid_review: 'للمراجعة',
    study_grid_unanswered: 'لم يُجب',
    study_grid_flagged: 'محددة',
    study_grid_remaining: 'متبقي',
    study_invalidQ: 'هذا السؤال يحتوي على خيارات غير صالحة',
    study_skipQ: 'تخطي السؤال ←',
    study_questionCorrect: 'هل السؤال صحيح؟',
    study_thankUp: 'شكراً! ✓',
    study_hintLoading: '✨ جاري توليد الشرح...',
    study_performExcellent: 'ممتاز! أنت قادر فعلاً 🔥',
    study_performGood: 'جيد جداً! واصل التدريب',
    study_performOk: 'مقبول، تحتاج مزيداً من التمرين',
    study_performBad: 'راجع المادة وحاول مجدداً 💪',
    study_star1: 'ضعيف 😕',
    study_star2: 'مقبول 😐',
    study_star3: 'جيد 🙂',
    study_star4: 'جيد جداً 😊',
    study_star5: 'ممتاز 🔥',
    study_seen: 'شاهدت',
    study_sessionsLeft: 'جلسة باقية',
    study_answered: 'أجبت',
    study_remaining: 'متبقي',
    study_total: 'المجموع',
    study_completed: 'مكتمل',
    study_sendReport: '📤 إرسال الإبلاغ',

    // ── ExamScreen (extra) ──
    exam_selectExam: 'اختر نوع الاختبار الذي تريد محاكاته',
    exam_quantLabel: 'القدرات العامة',
    exam_quantDesc: '65 كمي + 55 لفظي • 120 دقيقة',
    exam_tahsiliLabel: 'التحصيلي',
    exam_tahsiliDesc: '120 سؤال • 120 دقيقة',
    exam_back: '← رجوع',
    exam_backHome: '← رجوع للرئيسية',
    exam_done: 'انتهى الاختبار',
    exam_reviewTitle: 'مراجعة الإجابات',
    exam_reviewAnswers: '📋 مراجعة الإجابات',
    exam_filterAll: 'الكل',
    exam_filterWrong: 'الخاطئة',
    exam_filterUnanswered: 'غير مجاب',
    exam_noCategory: 'لا توجد أسئلة في هذا التصنيف',
    exam_submitBtn: 'تسليم ✓',
    exam_nav_current: 'الحالي',
    exam_nav_answered: 'أُجيب',
    exam_nav_unanswered: 'لم يُجَب',
    exam_nav_remaining: 'متبقي',
    exam_timeLeft: 'الوقت المتبقي:',
    exam_submitNow: '✅ تسليم الآن',
    exam_cancelContinue: '← إلغاء، أكمل الاختبار',
    exam_prev: '→ السابق',
    exam_next: 'التالي ←',
    exam_noQuestions: 'لا توجد أسئلة',
    exam_performExcellent: 'ممتاز! أنت قادر فعلاً 🔥',
    exam_performGood: 'جيد جداً! واصل التمرين',
    exam_performOk: 'مقبول، تحتاج مزيداً من الممارسة',
    exam_performBad: 'راجع المادة وحاول مجدداً 💪',
    exam_unansweredQ: '⚠️ لم تجب على هذا السؤال',
    exam_answered2: 'أجبت',

    // ── PaymentScreen (extra) ──
    payment_successTitle: 'تم الاشتراك بنجاح!',
    payment_activating: 'جاري تفعيل حسابك...',
    payment_errorTitle: 'حدث خطأ',
    payment_retry: 'حاول مجدداً',
    payment_backBtn: 'رجوع',
    payment_backArrow: '← رجوع',
    payment_monthly: 'اشتراك شهري • 30 يوم',
    payment_duration: '30 يوم',
    payment_formTitle: '💳 بيانات الدفع',
    payment_loadingPayment: '⏳ جاري معالجة الدفع...',
    payment_guarantee: '🔒 دفع آمن عبر موياسر • استرداد خلال 24 ساعة • إلغاء في أي وقت',
    payment_privacyLink: 'سياسة الخصوصية',
    payment_termsLink: 'الشروط والأحكام',
    payment_refundLink: 'سياسة الدفع والاسترجاع',
    payment_planBasic: 'أساسي',
    payment_planPro: 'متقدم',
    payment_planElite: 'شامل',
  },

  en: {
    // ── General ──
    appName: 'Qadder',
    appSlogan: 'You Can — Chart Your Path',
    logout: 'Logout',
    back: 'Back',
    loading: 'Loading...',
    loadingData: 'Loading your data...',
    save: 'Save',
    send: 'Send',
    cancel: 'Cancel',
    confirm: 'Confirm',
    error: 'Error',
    success: 'Success',
    perMonth: 'SAR/mo',
    currency: 'SAR',
    daysLeft: 'days left',
    readMore: 'Read more about Qadder →',

    // ── PhoneAuth ──
    auth_tagline: 'You Can — Chart Your Path to Excellence',
    auth_enterPhone: 'Enter your phone number',
    auth_smsSent: 'We will send you a verification code via SMS',
    auth_sendCode: 'Send Verification Code',
    auth_sending: 'Sending...',
    auth_browseAsGuest: '👀 Browse as Guest',
    auth_verifyTitle: 'Verification Code',
    auth_codeSentTo: 'We sent a code to',
    auth_verify: 'Verify & Login',
    auth_verifying: 'Verifying...',
    auth_resendAfter: 'Resend after',
    auth_resend: 'Resend Code',
    auth_changeNumber: 'Change Number',
    auth_agree: 'By continuing you agree to the Terms of Service',
    auth_invalidPhone: 'Enter a valid phone number',
    auth_invalidCode: 'Enter the verification code',
    auth_testimonialTitle: 'What our users say',
    auth_realRatings: 'Real ratings from Qadder users',

    // ── HomeScreen ──
    home_registerNow: 'Register Now',
    home_guestBanner: '👀 You are browsing as a guest',
    home_guestDesc: 'Register for free to save your progress and start real training',
    home_currentPlan: 'Your Subscription',
    home_planBadge: '',
    home_renewWarning: '⚠️ Your subscription is ending soon — Renew now to continue',
    home_stats: '📊 Your Stats',
    home_pdfReport: '📄 PDF Report',
    home_questionsAnswered: 'Questions answered',
    home_accuracy: 'Answer accuracy',
    home_trainingSessions: 'Training sessions',
    home_sessions: 'sessions',
    home_questions: 'questions',
    home_streak: 'consecutive • Streak',
    home_streakBest: 'Best:',
    home_day: 'day',
    home_days: 'days',
    home_startTraining: '🚀 Start Training',
    home_comingSoon: '🔜 Soon',
    home_upgrade: '🔒 Upgrade',
    home_upgradePlan: '⬆️ Upgrade Plan — View all plans',
    home_wrongAnswers: 'My Wrong Answers',
    home_wrongAnswersDesc: 'Review questions you got wrong and learn from them',
    home_officialExam: 'Official Exam Simulation',
    home_officialExamDesc: '120 questions • 65 Quant + 55 Verbal • 120 minutes',
    home_trialExam: 'Trial Test',
    home_trialExamDesc: '20 random questions from the question bank',
    home_recentSessions: '🕐 Recent Sessions',
    home_noSessions: 'No sessions yet',
    home_noSessionsDesc: 'Start training from the buttons above',
    home_trainingSession: 'Training Session',
    home_aboutTitle: 'Training platform for aptitude & achievement tests',
    home_aboutDesc: 'We empower every Saudi student to achieve their highest scores with the least effort and smartest method — organized daily training, real questions, and instant feedback.',
    home_feature1: 'Quant · Verbal · Achievement · STEP',
    home_feature2: 'Official Exam Simulation',
    home_feature3: 'Detailed performance reports',
    home_feature4: 'Wrong answers review',

    // ── Plans ──
    plans_title: 'Choose Your Plan',
    plans_subtitle: 'Start your journey to excellence',
    plans_yourScore: 'Your score:',
    plans_mostPopular: 'Most Popular',
    plans_subscribe: 'Subscribe to',
    plans_privacy: 'Privacy Policy',
    plans_terms: 'Terms & Conditions',
    plans_refund: 'Refund Policy',
    plans_basic: 'Basic',
    plans_pro: 'Pro',
    plans_elite: 'Elite',
    plans_basicDesc: 'For beginners',
    plans_proDesc: 'Most popular',
    plans_eliteDesc: 'Full experience',
    feat_qudraat: 'Aptitude questions (Quant + Verbal)',
    feat_trial: 'Trial test',
    feat_tahsili: 'Achievement questions (Math, Physics, Chemistry, Biology)',
    feat_unlimited: 'Unlimited questions',
    feat_ai: 'AI explanations ✨',
    feat_stats: 'Performance statistics',
    feat_progress: 'Detailed progress tracking',
    feat_step: 'STEP questions',
    feat_tajamuat: '🗂️ Tajamuat Updated',
    feat_support: 'Priority support',

    // ── Streak badges ──
    badge_champion: 'Champion',
    badge_advanced: 'Advanced',
    badge_committed: 'Committed',
    badge_regular: 'Regular',
    badge_beginner: 'Beginner',

    // ── Plan names ──
    plan_noSub: 'No subscription',
    plan_guest: 'Guest',

    // ── Modes ──
    mode_quant: 'Quant',
    mode_verbal: 'Verbal',
    mode_tahsili: 'Achievement',
    mode_tajamuat: 'Tajamuat Updated',

    // ── StudyScreen / ExamScreen ──
    study_report: 'Report an issue',
    study_note: 'Your notes on the question',
    study_submit: 'Submit Report',
    study_sending: 'Sending...',
    study_submitError: 'An error occurred, please try again',
    study_reportSent: '✅ Report sent, thank you!',
    study_explanation: 'Explanation',
    study_aiExplain: '✨ Explain with AI',
    study_loadingAi: '⏳ Generating explanation...',
    study_noExplan: 'No explanation available for this question',
    study_next: 'Next →',
    study_finish: 'End Session',
    study_question: 'Question',
    study_of: 'of',
    study_correct: 'Correct',
    study_wrong: 'Wrong',
    study_unanswered: 'Not answered',
    study_score: 'Your Score',
    study_accuracy: 'Accuracy',
    study_timeTaken: 'Time taken',
    study_restart: 'New Session',
    study_home: 'Home',
    study_reviewAnswers: 'Review Answers',
    study_hideReview: 'Hide Review',
    study_yourAnswer: 'Your answer:',
    study_correctAnswer: 'Correct answer:',
    study_loadingQuestions: 'Loading questions...',
    study_noQuestions: 'No questions available',
    study_errorLoading: 'Error loading questions',

    // ── ExamScreen ──
    exam_title: 'Official Exam Simulation',
    exam_quant: 'Quant',
    exam_verbal: 'Verbal',
    exam_timeUp: "Time's up!",
    exam_submitExam: 'Submit Exam',
    exam_confirmSubmit: 'Are you sure you want to submit the exam?',
    exam_yes: 'Yes, Submit',
    exam_no: 'No, Go back',
    exam_unansweredWarning: 'You have unanswered questions',

    // ── WrongAnswers ──
    wrong_title: 'My Wrong Answers',
    wrong_empty: 'No wrong answers yet!',
    wrong_emptyDesc: 'Keep training and questions you need to review will appear here',
    wrong_filter: 'Filter by subject',
    wrong_all: 'All',

    // ── PaymentScreen ──
    payment_title: 'Complete Subscription',
    payment_plan: 'Selected Plan',
    payment_total: 'Total Amount',
    payment_processing: 'Processing...',
    payment_pay: 'Pay Now',
    payment_success: '🎉 Subscription successful!',
    payment_failed: 'Payment failed, please try again',
    payment_back: 'Back to Plans',

    // ── Admin ──
    admin_title: 'Admin Panel',
    admin_home: 'Home',
    admin_visitors: 'Visitors',
    admin_users: 'Users',
    admin_paid: 'Payments',
    admin_questions: 'Questions',
    admin_hidden: 'Hidden Questions',
    admin_reports: 'Reports',
    admin_opinions: 'Opinions',
    admin_telegram: 'Telegram Bot',
    admin_totalRevenue: 'Total Revenue',
    admin_activeQuestions: 'Active Questions',
    admin_todaySessions: "Today's Sessions",
    admin_activeSubscribers: 'Active Subscribers',
    admin_totalUsers: 'Total Users',
    admin_activeBySubject: '📋 Active Questions by Subject',
    admin_subject: 'Subject',
    admin_count: 'Count',
    admin_pct: 'Percentage',
    admin_dashboard: 'Dashboard',

    // ── TrialQuiz ──
    trial_title: 'Trial Test',
    trial_subtitle: 'Test your level before subscribing',
    trial_home: '← Home',
    trial_savedSession: '⏸️ Saved Session',
    trial_answered: 'Answered',
    trial_from: 'of',
    trial_questions: 'questions',
    trial_resume: '▶ Resume',
    trial_chooseSection: '📚 Choose a section or leave on All:',
    trial_chooseSubject: '🎓 Choose a subject or leave on All:',
    trial_all: 'All',
    trial_start: 'Start Test 🚀',
    trial_skip: 'Skip to Plans',
    trial_login: '🔑 I have a subscription — Login',
    trial_loading: 'Loading questions...',
    trial_exit: '✕ Exit',
    trial_exitTitle: 'Do you want to exit?',
    trial_continueExam: '▶ Continue Test',
    trial_saveAndExit: '💾 Save Progress & Exit',
    trial_exitNoSave: 'Exit without saving',
    trial_navigate: 'Navigate questions',
    trial_correct: 'Correct',
    trial_wrong: 'Wrong',
    trial_remaining: 'Remaining',
    trial_next: 'Next →',
    trial_viewResult: 'View Result 🏆',
    trial_reportProblem: '🚩 Report a problem',
    trial_sendReport: '📤 Send Report',
    trial_reportSending: '⏳ Sending...',
    trial_reportFailed: '⚠️ Failed, try again',
    trial_sent: 'Sent',
    trial_thanks: 'Thank you for helping us improve',
    trial_result: 'Final Result',
    trial_correctFrom: 'correct answers out of',
    trial_aiAnalyze: 'Analyze my performance with AI',
    trial_aiStrengths: 'Your strengths, weaknesses & recommendation',
    trial_aiAnalyzing: '✨ Analyzing your performance...',
    trial_aiTitle: '🤖 AI Analysis',
    trial_subscribe: '🔓 Subscribe for +10,000 Questions ⭐',
    trial_shareWhatsapp: 'Share your result on WhatsApp',
    trial_writeReview: 'Write your review',
    trial_newTest: '🔄 New Test',
    trial_feedbackTitle: 'Your opinion matters',
    trial_feedbackSubtitle: 'How was your trial test experience?',
    trial_feedbackThanks: 'Thank you!',
    trial_feedbackHelped: 'Your feedback helps us improve Qadder',
    trial_feedbackSend: 'Send Review ✅',
    trial_feedbackSkip: 'Skip and Continue →',
    trial_feedbackChoose: 'Choose your rating first ☝️',
    trial_comingSoon: 'Soon',
    trial_questionCorrect: 'Is the question correct?',
    trial_additionalDetails: 'Additional details (optional)...',
    trial_questionNote: 'Your notes on the question',
    trial_kmi: 'Quant',
    trial_lafzi: 'Verbal',
    trial_secUnit: 's',
    trial_perQ: 'per Q',
    trial_explainLabel: 'Explain',
    trial_perAnswer: 'per answer',
    trial_fetchingSubject: 'Fetching {sub} questions only',

    // ── SubjectScreen ──
    subject_title: 'Choose Subject',
    subject_subtitle: 'Select the subject you want to train on',
    subject_questions: 'questions',
    subject_back: '← Back',

    // ── WrongAnswers ──
    wrong_back: '← Back',
    wrong_noExplain: 'No explanation',

    // ── StudyScreen (extra) ──
    study_savedSession: 'Saved Session',
    study_resumeBtn: '▶ Resume where you left off',
    study_newSessionBtn: '🔄 Start new session',
    study_empty: 'No Questions',
    study_emptyDesc: 'No questions available in this mode right now',
    study_sessionEnd: 'Session Ended',
    study_exit: '✕ Exit',
    study_exitTitle: 'Do you want to exit?',
    study_continueTraining: '▶ Continue Training',
    study_saveAndExit: '💾 Save Progress & Exit',
    study_exitNoSave: 'Exit without saving',
    study_navigate: 'Navigate Questions',
    study_viewResult: 'View Result 🏆',
    study_flag: '⚐ Flag for review',
    study_flagged: '⚑ Flagged',
    study_aiAnalyzeBtn: 'AI Performance Analysis',
    study_aiSubtitle: 'Strengths • Weaknesses • Next session recommendation',
    study_aiAnalyzing: '✨ Analyzing your performance...',
    study_aiTitle: '🤖 AI Analysis',
    study_shareWhatsapp: 'Share your result on WhatsApp',
    study_reportSentTitle: 'Sent',
    study_reportSentDesc: 'Thank you for helping us improve',
    study_reportProblem: '🚩 Report a problem with this question',
    study_reportSending: '⏳ Sending...',
    study_reportFailed: '⚠️ Failed, please try again',
    study_writeReview: 'Write your review',
    study_reviewDone: 'Thank you!',
    study_reviewHelps: 'Helps us improve the platform',
    study_chooseRating: 'Choose your rating first ☝️',
    study_sendReview: '✅ Submit Review',
    study_namePlaceholder: 'Your name (optional)',
    study_commentPlaceholder: 'Any notes to share? (optional)',
    study_stagePlaceholder: 'Grade level (optional)',
    study_detailsPlaceholder: 'Additional details (optional)...',
    study_grid_current: 'Current',
    study_grid_correct: 'Correct',
    study_grid_wrong: 'Wrong',
    study_grid_review: 'Flagged',
    study_grid_unanswered: 'Unanswered',
    study_grid_flagged: 'Flagged',
    study_grid_remaining: 'Remaining',
    study_invalidQ: 'This question has invalid options',
    study_skipQ: 'Skip Question →',
    study_questionCorrect: 'Is the question correct?',
    study_thankUp: 'Thanks! ✓',
    study_hintLoading: '✨ Generating explanation...',
    study_performExcellent: 'Excellent! You are capable 🔥',
    study_performGood: 'Great job! Keep training',
    study_performOk: 'Acceptable, needs more practice',
    study_performBad: 'Review the material and try again 💪',
    study_star1: 'Poor 😕',
    study_star2: 'Fair 😐',
    study_star3: 'Good 🙂',
    study_star4: 'Very Good 😊',
    study_star5: 'Excellent 🔥',
    study_seen: 'Seen',
    study_sessionsLeft: 'sessions left',
    study_answered: 'Answered',
    study_remaining: 'Remaining',
    study_total: 'Total',
    study_completed: 'complete',
    study_sendReport: '📤 Send Report',

    // ── ExamScreen (extra) ──
    exam_selectExam: 'Choose the exam type you want to simulate',
    exam_quantLabel: 'General Aptitude',
    exam_quantDesc: '65 Quant + 55 Verbal • 120 min',
    exam_tahsiliLabel: 'Achievement',
    exam_tahsiliDesc: '120 questions • 120 min',
    exam_back: '→ Back',
    exam_backHome: '→ Back to Home',
    exam_done: 'Exam Finished',
    exam_reviewTitle: 'Review Answers',
    exam_reviewAnswers: '📋 Review Answers',
    exam_filterAll: 'All',
    exam_filterWrong: 'Wrong',
    exam_filterUnanswered: 'Unanswered',
    exam_noCategory: 'No questions in this category',
    exam_submitBtn: 'Submit ✓',
    exam_nav_current: 'Current',
    exam_nav_answered: 'Answered',
    exam_nav_unanswered: 'Unanswered',
    exam_nav_remaining: 'Remaining',
    exam_timeLeft: 'Time remaining:',
    exam_submitNow: '✅ Submit Now',
    exam_cancelContinue: '→ Cancel, continue exam',
    exam_prev: '← Prev',
    exam_next: 'Next →',
    exam_noQuestions: 'No questions',
    exam_performExcellent: 'Excellent! You are capable 🔥',
    exam_performGood: 'Great job! Keep practicing',
    exam_performOk: 'Acceptable, needs more practice',
    exam_performBad: 'Review the material and try again 💪',
    exam_unansweredQ: '⚠️ You did not answer this question',
    exam_answered2: 'Answered',

    // ── PaymentScreen (extra) ──
    payment_successTitle: 'Subscription successful!',
    payment_activating: 'Activating your account...',
    payment_errorTitle: 'An error occurred',
    payment_retry: 'Try again',
    payment_backBtn: 'Back',
    payment_backArrow: '→ Back',
    payment_monthly: 'Monthly • 30 days',
    payment_duration: '30 days',
    payment_formTitle: '💳 Payment Details',
    payment_loadingPayment: '⏳ Processing payment...',
    payment_guarantee: '🔒 Secure via Moyasar • 24h refund • Cancel anytime',
    payment_privacyLink: 'Privacy Policy',
    payment_termsLink: 'Terms & Conditions',
    payment_refundLink: 'Payment & Refund Policy',
    payment_planBasic: 'Basic',
    payment_planPro: 'Pro',
    payment_planElite: 'Elite',
  },
};

export default translations;
